import HomePage from "@pages/home.page";
import LoginPage from "@pages/login.pages";
import ProfilePage from "@pages/profile.page";
import { monitoringRoute } from "./router/monitoring.route";
import { reconcileRoute } from "./router/reconcile.route";
import { reportingRoute } from "./router/reporting.route";
import { userRoute } from "./router/user.route";

export const routes = [
  {
    path: "/",
    element: <HomePage />,
    isAuth: true,
  },
  {
    path: "/login-page",
    element: <LoginPage />,
    isAuth: false,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
    isAuth: true,
  },
  ...reconcileRoute,
  ...userRoute,
  ...monitoringRoute,
  ...reportingRoute,
];